import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh"

const $api = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL,
})

$api.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token903573902390236490')}`;
    return config;
})

async function refreshAuthToken(failedRequest) {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/refresh`, {withCredentials: true});
        localStorage.setItem("token903573902390236490", response.data.accessToken);
        failedRequest.response.config.headers["Authorization"] = `Bearer ${response.data.accessToken}`;
        return Promise.resolve();
    } catch (e) {
        console.log("Пользователь не авторизован");
        // можно сделать редирект на /login, если нужно
        return Promise.reject(e);
    }
}

createAuthRefreshInterceptor($api, refreshAuthToken)

export default $api;